'use strict';/* global define */define('modules/my-organization/components/my-organization-tabs/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope", "Modals", "TeamFactory", "Me", "Recommendation", "Users", "UserList", "ROLES", "roleCheck"];
function controller($scope,Modals,TeamFactory,Me,Recommendation,Users,UserList,ROLES,roleCheck){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.isBusy=false;ctrl.me=Me.get();ctrl.teams=TeamFactory.my();ctrl.isSupervisor=ctrl.me.roles&&roleCheck(ROLES.supervisor);ctrl.newTeam={};if(ctrl.isSupervisor){ctrl.recommendations=Recommendation.query();ctrl.keyPerformers=Users.getKeyPerformers();ctrl.watchlist=Users.getWatchlist();}// ---
/**
     * Add new team
     */ctrl.addTeam=function(){ctrl.isBusy=true;TeamFactory.save({members:true},ctrl.newTeam).$promise.then(function(team){ctrl.teams.push(team);ctrl.newTeam={};}).catch(Modals.fail).finally(function(){ctrl.isBusy=false;});};/**
     * Check if the logged in user is team owner
     *
     * @param  {Object}  team - selected team
     *
     * @return {Boolean}      - result of the operation
     */ctrl.isTeamOwner=function(team){if(team.teamlead!==null){return team.teamlead.id!==ctrl.me.id;}};/**
     * Add new user to key performer colleciton
     *
     * @param {Object} user       - new user
     * @param {String} failureMsg - error key to be translated later on
     */ctrl.addKeyPerformer=function(user,failureMsg){UserList.addUser(user,ctrl.keyPerformers);};/**
     * Remove user from key performer colleciton
     *
     * @param {Object} $event - tiggered even
     * @param {Object} user   - new user
     * @param {String} users  - list of users
     */ctrl.removeKeyPerformer=function($event,user,users){UserList.removeUser(user,users,'DASHBOARD.KEY_PERFORMERS.DELETE');};/**
     * Add new user to watchlist colleciton
     *
     * @param {Object} user       - new user
     * @param {String} failureMsg - error key to be translated later on
     */ctrl.addWatchlistUser=function(user,failureMsg){UserList.addUser(user,ctrl.watchlist,failureMsg);};/**
     * Remove user from watchlist colleciton
     *
     * @param {Object} $event - triggered event
     * @param {Object} user   - new user
     * @param {Array} users   - list of users
     */ctrl.removeWatchlistUser=function($event,user,users){UserList.removeUser(user,users,'DASHBOARD.WATCHLIST.DELETE');};}module.exports=controller;});
